import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import React, { PropsWithChildren } from "react";
import { Badge } from "@components/ui/badge";
interface FixtureWrapperProps extends PropsWithChildren {
  variant?: "default" | "compact" | "full-bleed" | "labeled";
  label?: string;
  metadata?: React.ReactNode;
  noPadding?: boolean;
  className?: string;
}
export const FixtureWrapper = t0 => {
  const $ = _c(23);
  const {
    children,
    variant: t1,
    label,
    metadata,
    noPadding: t2,
    className
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const noPadding = t2 === undefined ? false : t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== className || $[1] !== label || $[2] !== noPadding || $[3] !== variant) {
    const paddingClasses = {
      default: "p-8 md:p-12 lg:p-16",
      compact: "p-4 md:p-6",
      "full-bleed": "p-0",
      labeled: "p-8 md:p-12 lg:p-16"
    };
    const borderRadiusClasses = {
      default: "rounded-md",
      compact: "rounded-md",
      "full-bleed": "rounded-md overflow-hidden",
      labeled: "rounded-md"
    };
    t4 = "region";
    t5 = label ? `Component variant: ${label}` : "Component demonstration";
    t6 = "w-full";
    t3 = cn("relative flex w-full items-center justify-center border border-muted-foreground/20 bg-muted/20", borderRadiusClasses[variant], noPadding ? "p-0" : paddingClasses[variant], className);
    $[0] = className;
    $[1] = label;
    $[2] = noPadding;
    $[3] = variant;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== label || $[9] !== variant) {
    t7 = (variant === "labeled" || label) && <Badge className="absolute top-5 right-5" variant="secondary">{label}</Badge>;
    $[8] = label;
    $[9] = variant;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== children || $[12] !== t3 || $[13] !== t7) {
    t8 = <div className={t3}>{t7}{children}</div>;
    $[11] = children;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== metadata) {
    t9 = metadata && <figcaption className="mt-2 text-sm text-muted-foreground">{metadata}</figcaption>;
    $[15] = metadata;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t8 || $[21] !== t9) {
    t10 = <figure role={t4} aria-label={t5} className={t6}>{t8}{t9}</figure>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};